import { render, staticRenderFns } from "./InputPassengersCounterButton.vue?vue&type=template&id=6c2f5cf5"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports